import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { CasinoAPI } from "../../api/casino";
import CasinoCard from "../../components/CasinoCard";
import { getCommaSeparatedString } from "../../constants/Helper";
import { CasinoResponse } from "../../constants/responses";
import PreLoader from "../../components/PreLoader";
import { useTranslation } from "react-i18next";
import { useIpDetails } from "../../services/ip_provider";

const Casinos = () => {
  const { t } = useTranslation();
  const { ipData, loading: ipLoading, error } = useIpDetails();
  const [countryFlag, setCountryFlag] = useState<string | null>(null);
  const [countryName, setCountryName] = useState<string | null>(null);
  const [onlineCasinos, setOnlineCasinos] = useState<CasinoResponse[]>();
  async function fetchCasinos() {
    try {
      const res = await CasinoAPI.getActive();
      if (res.data) {
        const casinos = res.data;
        const sortedCasinos = Array.isArray(casinos)
          ? casinos.sort(
              (a, b) => parseInt(a.homeSequence) - parseInt(b.homeSequence)
            )
          : [];
        setOnlineCasinos(sortedCasinos);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  useEffect(() => {
    if (ipData) {
      setCountryName(ipData.country_name);
      setCountryFlag(ipData.location.country_flag);
      fetchCasinos();
    }
  }, [ipData]);

  if (!countryName || !onlineCasinos) return <PreLoader />;
  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      {/* Navbar */}
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-1">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>

      {onlineCasinos && (
        <section className="w-full lg:w-[75%] flex flex-col justify-center items-center pb-3">
          <h2 className="my-[5rem] text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_casions")}
          </h2>
          <div className="w-[90%] lg:w-full ">
            {onlineCasinos.map((casino, index) => (
              <div className="w-full" key={index}>
                <CasinoCard
                  id={casino.id}
                  flag={countryFlag ?? ""}
                  country={countryName ?? ""}
                  allowedCountries={
                    casino.allowedCountries
                      ? getCommaSeparatedString(casino.allowedCountries)
                      : ""
                  }
                  index={index}
                  logo={casino.picture}
                  welcomeBonusText={casino.welcomeBonusText}
                  freeBonusText={casino.freeBonusText}
                  refURL={casino.refURL}
                />
              </div>
            ))}
          </div>
        </section>
      )}
    </Container>
  );
};

export default Casinos;
